var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var ScheduledUnpublishing = /** @class */ (function (_super) {
    __extends(ScheduledUnpublishing, _super);
    function ScheduledUnpublishing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new scheduled unpublishing
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-unpublishing/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledUnpublishing.prototype.create = function (itemId, body) {
        return this.rawCreate(Utils.toId(itemId), Utils.serializeRequestBody(body, {
            type: 'scheduled_unpublishing',
            attributes: ['unpublishing_scheduled_at', 'content_in_locales'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new scheduled unpublishing
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-unpublishing/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledUnpublishing.prototype.rawCreate = function (itemId, body) {
        return this.client.request({
            method: 'POST',
            url: "/items/".concat(itemId, "/scheduled-unpublishing"),
            body: body,
        });
    };
    /**
     * Delete a scheduled unpublishing
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-unpublishing/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledUnpublishing.prototype.destroy = function (itemId) {
        return this.rawDestroy(Utils.toId(itemId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Delete a scheduled unpublishing
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/scheduled-unpublishing/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    ScheduledUnpublishing.prototype.rawDestroy = function (itemId) {
        return this.client.request({
            method: 'DELETE',
            url: "/items/".concat(itemId, "/scheduled-unpublishing"),
        });
    };
    ScheduledUnpublishing.TYPE = 'scheduled_unpublishing';
    return ScheduledUnpublishing;
}(BaseResource));
export default ScheduledUnpublishing;
//# sourceMappingURL=ScheduledUnpublishing.js.map